var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image } from '@philips-internal/oswald-ui-components/lib/components';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import simpleAvatar from '../../assets/images/icons/avatar_user.svg';
import avatarExamSchedule from '../../assets/images/avatars/avatar-exam-schedule.svg';
import avatarPhysician from '../../assets/images/avatars/avatar-phys.svg';
import avatarService from '../../assets/images/global/avatar-service.svg';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import LostSVG from '../../assets/images/icons/Lost.svg';
import checkSVG from '../../assets/images/global/check-green.svg';
import RequestedSVG from '../../assets/images/icons/Requested.svg';
import InExecutionSVG from '../../assets/images/icons/In_execution.svg';
import CanceledSVG from '../../assets/images/icons/Canceled.svg';
import { getPreferredTime, getSubtitle } from '../../util/card-util';
import './card-appointments-small.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
const STATUS_ICON_MAP = {
    '10': checkSVG,
    '15': CanceledSVG,
    '20': LostSVG,
    '25': InExecutionSVG,
    '30': CanceledSVG,
    '35': ConfirmedSVG,
    '40': ConfirmedSVG,
    'P': InExecutionSVG,
    'R': RequestedSVG,
    'X': CanceledSVG,
};
const SCHEDULE_TYPE = {
    CHEMOTHERAPY: 'Q',
    CONSULTATION: 'C',
    EXAM: 'E',
    SERVICE: 'S',
    SURGERY: 'Y',
};
let CardAppointmentsSmall = class CardAppointmentsSmall extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            fullMode: true,
            visible: true,
            width: 12
        };
        this.getIcon = (ieScheduleType) => {
            switch (ieScheduleType) {
                case SCHEDULE_TYPE.EXAM: return avatarExamSchedule;
                case SCHEDULE_TYPE.SERVICE: return avatarService;
                case SCHEDULE_TYPE.SURGERY:
                case SCHEDULE_TYPE.CHEMOTHERAPY: return avatarPhysician;
                default: return simpleAvatar;
            }
        };
    }
    static { this.propTypes = {
        dsFotoBase64: string,
        dsStatus: string,
        dsSubTitulo: string,
        dsTitulo: string,
        dsTypeSchedule: string,
        dtAgendamento: string,
        hrAgendamento: string,
        ieScheduleType: string,
        ieStatus: string,
    }; }
    render() {
        const { onClick, dsFotoBase64, dsTitulo, dsTypeSchedule, ieScheduleType, dsSubTitulo, dtAgendamento, hrAgendamento, ieStatus } = this.props;
        const titleAvatar = dsTitulo ?? '-';
        const icon = this.getIcon(ieScheduleType);
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-appointments-schedule-small', selectionType: SelectionType.NONE, onClick: trigger(onClick, new ClickEvent()) },
            React.createElement("div", { className: "general-content" },
                React.createElement("div", { className: `card-status-bar--${ieStatus}` }),
                React.createElement("div", { className: 'main-content' },
                    React.createElement("div", { className: 'content-left' },
                        React.createElement(Avatar, { image: dsFotoBase64 ? dsFotoBase64 : icon, title: titleAvatar, subtitle: getSubtitle([dsTypeSchedule, dsSubTitulo]) })),
                    React.createElement("div", { className: 'content-right' },
                        React.createElement("div", { className: 'content-right-status' },
                            React.createElement(Image, { src: STATUS_ICON_MAP[ieStatus], className: 'status-icon', alt: '' })))),
                React.createElement("div", { className: 'footer' },
                    ModelService.format('date', dtAgendamento),
                    " - ",
                    getPreferredTime(hrAgendamento)))));
    }
};
CardAppointmentsSmall = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardAppointmentsSmall);
export default CardAppointmentsSmall;
//# sourceMappingURL=card-appointments-small.js.map